import React, { useEffect } from 'react';

const LEGACY_CONTRACT_SUPPORT_URL =
  'https://opendoorvalet.com/contact?topic=event-contract-link';

/**
 * Retired UUID-based event contract surface.
 *
 * Contract UUIDs are record identifiers, not signing capabilities. Current
 * customer agreements use the exact signing-token website route. This redirect
 * intentionally does not read contracts or forward the UUID.
 */
export default function LegacyEventContractLinkRedirect() {
  useEffect(() => {
    window.location.replace(LEGACY_CONTRACT_SUPPORT_URL);
  }, []);

  return (
    <main className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="max-w-md text-center" role="status">
        <h1 className="text-2xl font-semibold mb-3">This agreement link has moved</h1>
        <p className="text-gray-300 mb-6">
          We are taking you to Open Door Valet so our events team can provide a
          fresh, secure signing link.
        </p>
        <a
          href={LEGACY_CONTRACT_SUPPORT_URL}
          rel="noreferrer"
          className="inline-flex rounded-lg bg-[#AEA36D] px-5 py-3 font-semibold text-black"
        >
          Continue to Open Door Valet
        </a>
      </div>
    </main>
  );
}
